import XLienSideWrapper from "./XLienSideWrapper";

export default XLienSideWrapper;
